import { environment as Env } from './BaseEnvironments/Fortyfix';
var Environment = () => {
  var env= Env;
  env.apiUrl= 'https://www.sbsprogetti.cloud/api';
  env.logoPath = 'assets/images/FF_Logo.png';
  return env;
}

export var environment = Environment();
